module.exports = __webpack_public_path__ + "images/sortarr-top-green.svg?0c27e84d14e122aa15aaabc6c433712e";